import React from 'react';

export default function EditorToolbar(props: any) {

return (
  <div></div>
)
}